module.exports = __webpack_public_path__ + "img/CB[1]-W-1.e8aa5f8b.gif";